<template>
  <form class="inscricao-form" @submit.prevent="handleSubmit">
    <!-- Cabeçalho (read-only) -->
    <div v-if="acampante" class="form-header">
      <div class="form-header-name">{{ acampante.name }}</div>
      <div v-if="acampante.equipe" class="form-header-equipe">
        Equipe {{ equipeLabel }}
      </div>
    </div>

    <!-- Sexo -->
    <div class="form-section">
      <label class="label">Sexo *</label>
      <div class="radio-row">
        <label v-for="opt in sexos" :key="opt.value" class="radio-card" :class="{ active: form.sexo === opt.value }">
          <input type="radio" :value="opt.value" v-model="form.sexo" @change="handleSexoChange" />
          <span>{{ opt.label }}</span>
        </label>
      </div>
    </div>

    <!-- Idade -->
    <div class="form-section">
      <label class="label">Sou maior de 18 anos *</label>
      <div class="radio-row">
        <label class="radio-card" :class="{ active: form.maiorDeIdade === true }">
          <input type="radio" :value="true" v-model="form.maiorDeIdade" />
          <span>Sim</span>
        </label>
        <label class="radio-card" :class="{ active: form.maiorDeIdade === false }">
          <input type="radio" :value="false" v-model="form.maiorDeIdade" />
          <span>Não, sou menor</span>
        </label>
      </div>
    </div>

    <!-- Bloco do responsável (condicional) -->
    <div v-if="form.maiorDeIdade === false" class="form-section sub-section">
      <h3 class="sub-title">Dados do responsável</h3>
      <div class="field">
        <label class="label">Nome completo do responsável *</label>
        <input v-model.trim="form.responsavelNome" class="input" type="text" />
      </div>
      <div class="field-row">
        <div class="field">
          <label class="label">Telefone do responsável *</label>
          <input v-model.trim="form.responsavelTelefone" class="input" type="tel" placeholder="(00) 00000-0000" />
        </div>
        <div class="field">
          <label class="label">Parentesco *</label>
          <input v-model.trim="form.responsavelParentesco" class="input" type="text" placeholder="Ex: Mãe, Pai" />
        </div>
      </div>
      <div class="field">
        <label class="label">CPF do responsável (opcional)</label>
        <input v-model.trim="form.responsavelCpf" class="input" type="text" placeholder="000.000.000-00" />
      </div>
    </div>

    <!-- Acomodação -->
    <div class="form-section">
      <label class="label">Onde vai dormir? *</label>
      <div class="radio-row">
        <label
          v-for="opt in acomodacoesDisponiveis"
          :key="opt.value"
          class="radio-card"
          :class="{ active: form.acomodacao === opt.value }"
        >
          <input type="radio" :value="opt.value" v-model="form.acomodacao" />
          <span>{{ opt.label }}</span>
        </label>
      </div>
      <p v-if="alojamentoReset" class="hint hint-warning">
        Alojamento disponível apenas para acampantes do sexo feminino.
      </p>
    </div>

    <!-- Transporte ida -->
    <div class="form-section">
      <label class="label">Como vai pro acamp (ida)? *</label>
      <div class="radio-row">
        <label v-for="opt in transportes" :key="opt.value" class="radio-card" :class="{ active: form.transporte === opt.value }">
          <input type="radio" :value="opt.value" v-model="form.transporte" />
          <span>{{ opt.label }}</span>
        </label>
      </div>
      <div class="aviso-volta">
        <i class="fa fa-exclamation-triangle"></i>
        <span>{{ avisoVolta }}</span>
      </div>
    </div>

    <!-- Saúde -->
    <div class="form-section">
      <h3 class="sub-title">Saúde</h3>
      <div class="field">
        <label class="label">Alergias (opcional)</label>
        <textarea
          v-model.trim="form.alergias"
          class="input textarea"
          rows="2"
          placeholder="Ex: amendoim, lactose, picada de inseto..."
        ></textarea>
      </div>
      <div class="field">
        <label class="label">Restrição alimentar (opcional)</label>
        <div class="chips-row">
          <label
            v-for="opt in restricoesOpcoes"
            :key="opt.value"
            class="chip"
            :class="{ active: form.restricaoChips.includes(opt.value) }"
          >
            <input
              type="checkbox"
              :value="opt.value"
              v-model="form.restricaoChips"
            />
            <span>{{ opt.label }}</span>
          </label>
        </div>
        <input
          v-model.trim="form.restricaoOutro"
          class="input"
          type="text"
          placeholder="Outra restrição (opcional)"
          style="margin-top: 8px;"
        />
      </div>
      <div class="field">
        <label class="label">Usa medicamento contínuo? (opcional)</label>
        <textarea
          v-model.trim="form.medicamentos"
          class="input textarea"
          rows="2"
          placeholder="Ex: Ritalina, antialérgico..."
        ></textarea>
      </div>
      <div class="field">
        <label class="label">Condição de saúde relevante? (opcional)</label>
        <textarea
          v-model.trim="form.condicoesSaude"
          class="input textarea"
          rows="2"
          placeholder="Ex: asma, diabetes, ansiedade..."
        ></textarea>
      </div>
    </div>

    <!-- Contato de emergência -->
    <div class="form-section">
      <h3 class="sub-title">Contato de emergência</h3>
      <div class="field">
        <label class="label">Nome completo *</label>
        <input v-model.trim="form.emergenciaNome" class="input" type="text" />
      </div>
      <div class="field-row">
        <div class="field">
          <label class="label">Telefone *</label>
          <input v-model.trim="form.emergenciaTelefone" class="input" type="tel" placeholder="(00) 00000-0000" />
        </div>
        <div class="field">
          <label class="label">Parentesco *</label>
          <input v-model.trim="form.emergenciaParentesco" class="input" type="text" placeholder="Ex: Pai, Mãe, Irmão" />
        </div>
      </div>
    </div>

    <!-- Termos -->
    <div class="form-section" v-if="mode !== 'admin'">
      <h3 class="sub-title">Termos de responsabilidade *</h3>
      <label class="termo">
        <input type="checkbox" v-model="form.termoTalher" />
        <span>Comprometo-me a levar copo e talher de uso pessoal.</span>
      </label>
      <label class="termo">
        <input type="checkbox" v-model="form.termoPertences" />
        <span>Sou responsável pelos meus próprios pertences.</span>
      </label>
      <label class="termo">
        <input type="checkbox" v-model="form.termoIdade" />
        <span>Confirmo que sou maior de 18 anos OU estou acompanhado(a) do(a) responsável legal.</span>
      </label>
    </div>

    <!-- Admin: checkbox aceitouTermos resumido -->
    <div class="form-section" v-else>
      <label class="termo">
        <input type="checkbox" v-model="form.aceitouTermos" />
        <span>Acampante aceitou os termos de responsabilidade</span>
      </label>
    </div>

    <!-- Erro global -->
    <div v-if="errorMessage" class="error-banner">
      <i class="fa fa-exclamation-circle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Helper de validação -->
    <p v-if="mode !== 'admin' && !termosOk && !errorMessage" class="hint">
      Você precisa aceitar todos os termos para enviar.
    </p>

    <!-- Botões -->
    <div class="form-actions">
      <button
        v-if="mode !== 'public' || $emit"
        type="button"
        class="btn-secondary"
        @click="$emit('cancel')"
        :disabled="submitting"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="btn-primary submit-btn"
        :disabled="!canSubmit || submitting"
      >
        <span v-if="submitting"><i class="fa fa-spinner fa-spin"></i> Enviando...</span>
        <span v-else-if="mode === 'admin'">Salvar alterações</span>
        <span v-else-if="mode === 'checkin'">Salvar ficha</span>
        <span v-else>Enviar inscrição</span>
      </button>
    </div>

    <!-- Admin: reabrir ficha -->
    <div v-if="mode === 'admin' && acampante?.fichaPreenchidaEm" class="reopen-row">
      <button type="button" class="btn-link-danger" @click="handleReopen">
        Reabrir ficha (acampante poderá preencher novamente)
      </button>
    </div>
  </form>
</template>

<script>
import { SEXOS } from '../lib/sexos'
import { acomodacoesDisponiveis } from '../lib/acomodacoes'
import { TRANSPORTES, AVISO_VOLTA } from '../lib/transportes'
import {
  RESTRICOES_OPCOES,
  submitInscricao,
  parseRestricoes,
  serializeRestricoes
} from '../lib/inscricao'
import apiClient from '../lib/api'
import { EQUIPES } from '../lib/equipes'

const EMPTY_FORM = {
  sexo: null,
  maiorDeIdade: null,
  responsavelNome: '',
  responsavelTelefone: '',
  responsavelCpf: '',
  responsavelParentesco: '',
  acomodacao: null,
  transporte: null,
  alergias: '',
  restricaoChips: [],
  restricaoOutro: '',
  medicamentos: '',
  condicoesSaude: '',
  emergenciaNome: '',
  emergenciaTelefone: '',
  emergenciaParentesco: '',
  termoTalher: false,
  termoPertences: false,
  termoIdade: false,
  aceitouTermos: false
}

export default {
  name: 'InscricaoForm',
  props: {
    mode: {
      type: String,
      default: 'public',
      validator: v => ['public', 'admin', 'checkin'].includes(v)
    },
    acampante: { type: Object, default: null },
    initialData: { type: Object, default: null }
  },
  emits: ['submit-success', 'cancel', 'error', 'reopen'],
  data() {
    return {
      form: { ...EMPTY_FORM },
      submitting: false,
      errorMessage: '',
      alojamentoReset: false
    }
  },
  computed: {
    sexos() { return SEXOS },
    transportes() { return TRANSPORTES },
    restricoesOpcoes() { return RESTRICOES_OPCOES },
    avisoVolta() { return AVISO_VOLTA },
    acomodacoesDisponiveis() { return acomodacoesDisponiveis(this.form.sexo) },
    equipeLabel() {
      const e = EQUIPES.find(eq => eq.value === this.acampante?.equipe)
      return e?.label || this.acampante?.equipe
    },
    termosOk() {
      if (this.mode === 'admin') return true
      return this.form.termoTalher && this.form.termoPertences && this.form.termoIdade
    },
    obrigatoriosOk() {
      if (!this.form.sexo) return false
      if (this.form.maiorDeIdade === null) return false
      if (!this.form.acomodacao) return false
      if (!this.form.transporte) return false
      if (!this.form.emergenciaNome || !this.form.emergenciaTelefone || !this.form.emergenciaParentesco) return false
      if (this.form.maiorDeIdade === false) {
        if (!this.form.responsavelNome || !this.form.responsavelTelefone || !this.form.responsavelParentesco) return false
      }
      return true
    },
    canSubmit() {
      return this.obrigatoriosOk && this.termosOk
    }
  },
  watch: {
    initialData: {
      immediate: true,
      handler(val) {
        if (!val) return
        this.hydrateFromData(val)
      }
    }
  },
  methods: {
    hydrateFromData(d) {
      const restricoes = parseRestricoes(d.restricaoAlimentar)
      this.form = {
        ...EMPTY_FORM,
        sexo: d.sexo || null,
        maiorDeIdade: d.responsavelNome ? false : (d.sexo || d.acomodacao ? true : null),
        responsavelNome: d.responsavelNome || '',
        responsavelTelefone: d.responsavelTelefone || '',
        responsavelCpf: d.responsavelCpf || '',
        responsavelParentesco: d.responsavelParentesco || '',
        acomodacao: d.acomodacao || null,
        transporte: d.transporte || null,
        alergias: d.alergias || '',
        restricaoChips: restricoes.chips,
        restricaoOutro: restricoes.outro,
        medicamentos: d.medicamentos || '',
        condicoesSaude: d.condicoesSaude || '',
        emergenciaNome: d.emergenciaNome || '',
        emergenciaTelefone: d.emergenciaTelefone || '',
        emergenciaParentesco: d.emergenciaParentesco || '',
        termoTalher: !!d.aceitouTermos,
        termoPertences: !!d.aceitouTermos,
        termoIdade: !!d.aceitouTermos,
        aceitouTermos: !!d.aceitouTermos
      }
    },
    handleSexoChange() {
      if (this.form.sexo !== 'F' && this.form.acomodacao === 'ALOJAMENTO') {
        this.form.acomodacao = null
        this.alojamentoReset = true
        setTimeout(() => { this.alojamentoReset = false }, 4000)
      }
    },
    buildPayload() {
      const restricao = serializeRestricoes(this.form.restricaoChips, this.form.restricaoOutro)
      return {
        sexo: this.form.sexo,
        maiorDeIdade: this.form.maiorDeIdade,
        responsavelNome: this.form.responsavelNome || null,
        responsavelTelefone: this.form.responsavelTelefone || null,
        responsavelCpf: this.form.responsavelCpf || null,
        responsavelParentesco: this.form.responsavelParentesco || null,
        acomodacao: this.form.acomodacao,
        transporte: this.form.transporte,
        alergias: this.form.alergias || null,
        restricaoAlimentar: restricao,
        medicamentos: this.form.medicamentos || null,
        condicoesSaude: this.form.condicoesSaude || null,
        emergenciaNome: this.form.emergenciaNome,
        emergenciaTelefone: this.form.emergenciaTelefone,
        emergenciaParentesco: this.form.emergenciaParentesco,
        aceitouTermos: this.mode === 'admin' ? this.form.aceitouTermos : (this.form.termoTalher && this.form.termoPertences && this.form.termoIdade)
      }
    },
    async handleSubmit() {
      if (!this.canSubmit) return
      this.errorMessage = ''
      this.submitting = true
      try {
        const payload = this.buildPayload()
        if (this.mode === 'admin') {
          // Quando admin preenche pela primeira vez, marca o timestamp.
          // Se a ficha já tinha sido enviada, mantém o original.
          if (!this.acampante?.fichaPreenchidaEm) {
            payload.fichaPreenchidaEm = new Date().toISOString()
          }
          const { data } = await apiClient.patch(`/atualizar/${this.acampante.id}`, payload)
          this.$emit('submit-success', { acampante: data.acampante, payload })
        } else {
          const res = await submitInscricao(this.acampante.id, payload)
          this.$emit('submit-success', { fichaPreenchidaEm: res.fichaPreenchidaEm, payload })
        }
      } catch (err) {
        const status = err?.response?.status
        const body = err?.response?.data
        if (status === 409 && body?.code === 'JA_PREENCHIDA') {
          this.$emit('error', { code: 'JA_PREENCHIDA', suporteContato: body.suporteContato })
          return
        }
        this.errorMessage = body?.message || 'Não foi possível enviar. Tente novamente em alguns segundos.'
        this.$emit('error', { message: this.errorMessage })
      } finally {
        this.submitting = false
      }
    },
    async handleReopen() {
      if (!confirm('Reabrir ficha permite que o acampante preencha novamente pelo link público. Continuar?')) return
      this.errorMessage = ''
      this.submitting = true
      try {
        const { data } = await apiClient.patch(`/atualizar/${this.acampante.id}`, { fichaPreenchidaEm: null })
        this.$emit('reopen', { acampante: data.acampante })
      } catch (err) {
        this.errorMessage = err?.response?.data?.message || 'Falha ao reabrir ficha.'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.inscricao-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  font-family: var(--font-primary);
  color: var(--color-text-primary);
}

.form-header {
  background: var(--color-bg-hover);
  border-radius: var(--radius-md);
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-header-name {
  font-size: var(--text-lg);
  font-weight: 700;
}
.form-header-equipe {
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}
.sub-section {
  background: #fafafa;
  padding: 16px;
  border-radius: var(--radius-md);
  border-left: 3px solid var(--color-accent);
}
.sub-title {
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--color-text-heading);
  margin: 0 0 6px 0;
}

.field { display: flex; flex-direction: column; gap: 4px; }
.field-row { display: flex; gap: var(--spacing-md); flex-wrap: wrap; }
.field-row .field { flex: 1; min-width: 140px; }

.label {
  display: block;
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--color-text-heading);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  background: #fff;
  font-family: var(--font-primary);
  color: var(--color-text-primary);
  outline: none;
  transition: var(--transition-fast);
  box-sizing: border-box;
}
.input:focus { border-color: var(--color-accent); box-shadow: 0 0 0 3px rgba(51, 102, 204, 0.15); }
.textarea { resize: vertical; min-height: 56px; }

.radio-row { display: flex; gap: 10px; flex-wrap: wrap; }
.radio-card {
  flex: 1;
  min-width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 12px;
  border: 2px solid #e0e0e0;
  border-radius: var(--radius-md);
  background: #fff;
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: var(--transition-fast);
}
.radio-card input { display: none; }
.radio-card:hover { border-color: var(--color-accent); }
.radio-card.active {
  border-color: var(--color-accent);
  background: rgba(51, 102, 204, 0.08);
  color: var(--color-accent);
}

.chips-row { display: flex; gap: 8px; flex-wrap: wrap; }
.chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border: 1.5px solid #ddd;
  border-radius: 999px;
  background: #fff;
  font-size: var(--text-xs);
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  color: var(--color-text-secondary);
}
.chip input { display: none; }
.chip.active {
  border-color: var(--color-accent);
  background: rgba(51, 102, 204, 0.08);
  color: var(--color-accent);
}

.aviso-volta {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fff8e1;
  color: #7a4f01;
  border-left: 4px solid #f9a825;
  padding: 10px 14px;
  border-radius: var(--radius-md);
  font-size: var(--text-xs);
  line-height: 1.4;
  margin-top: 6px;
}
.aviso-volta i { margin-top: 2px; }

.termo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  font-size: var(--text-sm);
  cursor: pointer;
  user-select: none;
  line-height: 1.4;
}
.termo input { margin-top: 3px; flex-shrink: 0; }

.hint {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin: 4px 0;
}
.hint-warning { color: #7a4f01; background: #fff8e1; padding: 8px 12px; border-radius: var(--radius-md); }

.error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffebee;
  color: var(--color-danger);
  padding: 10px 14px;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
}

.form-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: flex-end;
  margin-top: var(--spacing-md);
}
.submit-btn { flex: 1; max-width: 280px; justify-content: center; }

.reopen-row { margin-top: var(--spacing-md); text-align: center; }
.btn-link-danger {
  background: none;
  border: none;
  color: var(--color-danger);
  font-size: var(--text-xs);
  cursor: pointer;
  text-decoration: underline;
  padding: 8px;
}
.btn-link-danger:hover { color: #c0392b; }

@media (max-width: 540px) {
  .radio-card { min-width: calc(50% - 5px); }
  .form-actions { flex-direction: column-reverse; }
  .submit-btn { max-width: none; width: 100%; }
}
</style>
